import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Account from "../helpers/Account";
import Api from "../Api";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TestMode from "../components/TestMode";
import _ from 'lodash';
import Comment from "../components/Comment";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { profileRequest, profileUrsRequest, userInBlockRequest } from "../store/actions/users";
import Cookies from "js-cookie";
import qs from "query-string";
import Billing from "../components/Billing";
import UrsAdd from "../components/UrsAdd";
import UrsReport from "../components/UrsReport";
import UrsVoip from "../components/UrsVoip";
import { Helmet } from "react-helmet";
import { REACT_APP_API_URL } from '../config';
import BillingPop from "../components/BillingPop";
import TestPop from "../components/TestPop";
import DisabledPop from "../components/DisabledPop";
import MatrixPop from "../components/MatrixPop";
import UrsHeader from "../components/UrsHeader";
import { Tooltip } from 'react-tooltip';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Box, Typography } from "@mui/material";
import UrsLine from "../components/UrsLine";

const { REACT_APP_SERVER } = process.env;

function Urs(props) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()
    const query = qs.parse(location.search, { arrayFormat: 'comma' });
    const profile = useSelector(state => state.users.ursData)
    const [data, setData] = useState({})
    const [test, setTest] = useState({ id: 0 })
    const [comment, setComment] = useState(false)
    const [billing, setBilling] = useState({ member: 0, name: '' })
    const [add, setAdd] = useState(false)
    const [search, setSearch] = useState('')
    const [gumar, setGumar] = useState('')
    const [report, setReport] = useState('')
    const [voip, setVoip] = useState(false)
    const [loading, setLoading] = useState(false)
    const tableRef = useRef();
    const [isSticky, setIsSticky] = useState(false);
    const [headerLeft, setHeaderLeft] = useState(0);
    const [headerWidth, setHeaderWidth] = useState(0);
    const [columnWidths, setColumnWidths] = useState([]);

    useEffect(() => {
        (async () => {
            await dispatch(userInBlockRequest())
        })()
    }, [])
    const headerCellRefs = useRef([]);

    useEffect(() => {
        const updateHeaderState = () => {
            const rect = tableRef.current?.getBoundingClientRect();
            const thead = tableRef.current?.querySelector('thead');
            const theadHeight = thead?.offsetHeight || 0;

            if (rect) {
                const inView = rect.top <= 0 && rect.bottom > theadHeight;
                setIsSticky(inView);
                setHeaderLeft(rect.left);
                setHeaderWidth(rect.width);
            }

            const thElements = tableRef.current?.querySelectorAll('thead th');
            if (thElements?.length) {
                const widths = Array.from(thElements).map((th) => th.offsetWidth);
                setColumnWidths(widths);
            }
        };

        updateHeaderState();
        window.addEventListener('scroll', updateHeaderState);
        window.addEventListener('resize', updateHeaderState);
        return () => {
            window.removeEventListener('scroll', updateHeaderState);
            window.removeEventListener('resize', updateHeaderState);
        };
    }, []);

    const renderHeader = (isFixed = false) => (
        <tr>
            {['NN', 'Ամսաթիվ', 'Օգտատեր',
                <MatrixPop />, 'Հեռ', 'Անուն Ազգանուն', 'VIP', 'Մնացորդ (Դրամ)', 'Ծառայության գին',
                <TestPop />, profile.admingroup === 2 ? <span>Terminated</span> : <BillingPop billing={data.billings} />,
                <DisabledPop />, 'Disabl. Date', 'H', 'R', 'L', 'Comment', ''
            ].map((Component, index) => (
                <th
                    key={index}
                    ref={(el) => !isFixed && (headerCellRefs.current[index] = el)}
                    style={isFixed && columnWidths[index] ? { width: columnWidths[index] } : {}}
                >
                    {Component}
                </th>
            ))}
        </tr>
    );

    useEffect(() => {
        if (!Account.getUrsToken()) {
            navigate('/admin_login')
        }
    }, [])
    useEffect(() => {
        (async () => {
            try {
                setLoading(true)
                setData([])
                const { data } = await Api.members(query.page || 1, query.search || '', query.billing || '', query.testmode || '', query.isblocked || '', query.matrix || '', query.gumar || '', query.isActive || 'all')
                setData(data)
                setSearch(query.search || '')
                setLoading(false)

            } catch (e) {
            }
        })()
    }, [location.search])

    useEffect(() => {
        (async () => {
            await dispatch(profileUrsRequest())
        })()
    }, [])

    const handlePagination = useCallback(async (num) => {
        query.page = num;
        navigate(`?${qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })}`);
    }, [location.search])

    const handleTest = useCallback(async (id) => {
        try {
            for (const idElement of data.groupedArray) {
                for (const member of idElement.members) {
                    if (+member.id === +id) {
                        if (member.testmode) {
                            await Api.test_mode(id, 'off', location.pathname)
                        }
                    }
                }
            }

            setData((prevData) => {
                const updatedGroupedArray = prevData.groupedArray.map((prevDatum) => {
                    const updatedMembers = prevDatum.members.map((member) => {
                        if (+member.id === +id) {
                            if (!member.testmode) {
                                setTest(member);
                                return member;
                            } else {
                                return { ...member, testmode: !member.testmode, test_period: null };
                            }
                        }
                        return member;
                    });

                    return { ...prevDatum, members: updatedMembers };
                });

                return { ...prevData, groupedArray: updatedGroupedArray }; // Update the entire state
            });
        } catch (e) {
            console.log(e)
            toast.error(e.response.data.message)
        }
    }, [data]);

    const handleId = useCallback(async (id) => {
        try {
            Cookies.set('viewer', id, { expires: 30 })
            Cookies.set('original', profile.id, { expires: 30 })
            Cookies.set('key', profile.uid, { expires: 30 })
            const { data } = await Api.loginAsUser(id, profile.id, profile.uid)
            localStorage.setItem('access_token', data.access_token)
            localStorage.setItem('refresh_token', data.refresh_token)
            await dispatch(profileRequest())
            window.open(REACT_APP_API_URL, '_blank');
            // navigate('/')
        } catch (e) {

        }
    }, [profile, REACT_APP_API_URL])
    const handleSearch = useCallback((ev) => {
        ev.preventDefault()
        const cleaned = search.replace(/\s+/g, '');
        const isNumeric = /^\d+$/.test(cleaned);
        if (isNumeric) {
            query.search = cleaned;
        } else {
            query.search = search;
        }

        if (gumar) {
            query.gumar = gumar;
        }
        query.page = '';
        navigate(`?${qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })}`);
    }, [search, location.search, gumar])

    const handleActive = useCallback((ev) => {
        query.isActive = ev;
        console.log(ev)
        if (gumar) {
            query.gumar = gumar;
        }
        if (search) {
            query.search = search;
        }
        query.page = '';
        navigate(`?${qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })}`);
    }, [search, location.search, gumar])

    const handleBlock = useCallback(async (id) => {
        try {
            let text = +localStorage.getItem('atsLang') === 1 ? "Are you sure you want to change status?" :
                +localStorage.getItem('atsLang') === 2 ? "Вы уверены, что хотите изменить?" :
                    "Վստա՞հ եք, որ ցանկանում եք փոփոխել տողը";

            if (confirm(text) === true) {
                try {
                    setLoading(true)
                    for (const idElement of data.groupedArray) {
                        for (const member of idElement.members) {
                            if (+member.id === +id) {
                                await Api.blocked(id, +!member.isblocked)
                            }
                        }
                    }
                    setData((prevData) => {
                        const updatedGroupedArray = prevData.groupedArray.map((prevDatum) => {
                            const updatedMembers = prevDatum.members.map((member) => {
                                if (member.id === id) {
                                    if (member.isblocked) {
                                        return { ...member, testmode: 0, isblocked: !member.isblocked };
                                    } else {
                                        return { ...member, isblocked: !member.isblocked };

                                    }
                                }
                                return member;
                            });

                            return { ...prevDatum, members: updatedMembers };
                        });

                        return { ...prevData, groupedArray: updatedGroupedArray }; // Update the entire state
                    });
                    setLoading(false)
                } catch (e) {
                    toast.error(e.response.data.message)
                }

            }
        } catch (e) {
            console.log(e)
        }
    }, [data])
    const handleToCart = useCallback(async (id) => {
        try {
            setLoading(true)
            for (const idElement of data.groupedArray) {
                for (const member of idElement.members) {
                    if (+member.id === +id) {
                        await Api.inBasket(id, member.inMemBlock ? +!member.inMemBlock.status : 1)
                    }
                }
            }
            setData((prevData) => {
                const updatedGroupedArray = prevData.groupedArray.map((prevDatum) => {
                    const updatedMembers = prevDatum.members.map((member) => {
                        if (member.id === id) {
                            if (member.inMemBlock && member.inMemBlock.status) {
                                return { ...member, inMemBlock: { status: 0 } };
                            } else {
                                return { ...member, inMemBlock: { status: 1 } };

                            }
                        }
                        return member;
                    });

                    return { ...prevDatum, members: updatedMembers };
                });

                return { ...prevData, groupedArray: updatedGroupedArray }; // Update the entire state
            });
            await dispatch(userInBlockRequest())
            setLoading(false)
        } catch (e) {
            toast.error(e.response.data.message)
        }

    }, [data])
    const [isOpen, setIsOpen] = useState('')
    const handleTerminated = useCallback(async (id) => {
        try {
            let text = +localStorage.getItem('atsLang') === 1 ? "Are you sure you want to change status?" :
                +localStorage.getItem('atsLang') === 2 ? "Вы уверены, что хотите изменить?" :
                    "Վստա՞հ եք, որ ցանկանում եք փոփոխել տողը";

            if (confirm(text) !== true) return;
            setLoading(true)
            for (const idElement of data.groupedArray) {
                for (const member of idElement.members) {
                    if (+member.id === +id) {
                        await Api.terminated(id, Number(member.terminated) ? 0 : 1)
                    }
                }
            }
            setData((prevData) => {
                const updatedGroupedArray = prevData.groupedArray.map((prevDatum) => {
                    const updatedMembers = prevDatum.members.map((member) => {
                        if (+member.id === +id) {
                            return { ...member, terminated: Number(member.terminated) ? 0 : 1 };
                        }
                        return member;
                    });
                    return { ...prevDatum, members: updatedMembers };
                });
                return { ...prevData, groupedArray: updatedGroupedArray };
            })
            setLoading(false)
        } catch (e) {
            console.log(e)
            setLoading(false)
            toast.error(e.response.data.message)
        }
    }, [data])
    const handleChange = useCallback(async (ev, type) => {
        try {
            if (['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'].includes(ev.target.files[0].type) || (ev.target.files[0].name?.endsWith('.xlsx') || ev.target.files[0].name?.endsWith('.csv'))) {
                toast.info('Please wait')
                let data = []
                if (type === 'itn') {
                    data = await Api.uploadINT(ev.target.files[0])
                    data = [...data.data.exelArr, ...data.data.memberArr]
                } else {
                    data = await Api.uploadTurnOff(ev.target.files[0])
                }
                if (data.length) {
                    toast.success('Success. Downloading not changed data')
                    const workbook = XLSX.utils.book_new();
                    const worksheet = XLSX.utils.aoa_to_sheet(data);
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
                    const fileData = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    saveAs(fileData, "data.xlsx");
                } else {
                    toast.success('Success')
                }
            } else {
                toast.error('It should be an exel file')
            }
        } catch (e) {

        }
    }, [])
    return (
        <>
            <Helmet>
                <title>Admin Panel</title>
            </Helmet>
            <UrsHeader />
            <div className="urs_table" style={{ display: 'flex', justifyContent: 'center', paddingTop:20 }}>
                <div className="container tableParent  file" style={window.innerWidth <= 1024 ? {
                    overflow: 'auto',
                    background: 'white',
                    padding: "35px 15px 15px 15px"
                } : { background: 'white', padding: "35px 15px 35px 15px" }}>
                    <div className="d-flex flex-row justify-content-between align-items-center">
                        <div>
                            <div>
                                <span className="custom_span" style={{ cursor: 'pointer' }}
                                    onClick={() => setReport('prev')}>Download Previous Month Report</span> / <span
                                        className="custom_span"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setReport('now')}>Download Month Report</span></div>
                            <hr />
                            <div>
                                <span className="custom_span" style={{ cursor: 'pointer', marginRight: 5 }}
                                    onClick={() => setAdd(true)}>Add</span>
                                |
                                <span className="custom_span" style={{ cursor: 'pointer', margin: 5 }}
                                    onClick={() => setVoip(true)}>VoIP Report</span>
                                |
                                {!profile.isLimited ?
                                    <Link className="custom_span" style={{ cursor: 'pointer', margin: 5, color: '#5e8516' }} to="/urs_used"
                                        target="_blank"
                                        rel="noopener noreferrer">{REACT_APP_SERVER === 'Beeline' ? 'Beeline' : 'V-Office'} Used</Link> : null}
                                |{!profile.isLimited ?
                                    <Link to="/urs_blocked" style={{ color: '#5e8516' }}>
                                        <span className="custom_span"
                                            style={{ cursor: 'pointer', margin: 5 }}>{REACT_APP_SERVER === 'Beeline' ? 'Beeline' : 'V-Office'} Blocked</span>

                                    </Link> : null}
                                |<Link className="custom_span" style={{ cursor: 'pointer', margin: 5, color: '#5e8516' }} to="/report">Report
                                    Traffic </Link> |
                                <Link className="custom_span" style={{ cursor: 'pointer', margin: 5, color: '#5e8516' }} to="/urs_promocodes">Promocodes</Link> |
                                {!profile.isLimited ?
                                    <label>
                                        <span className="custom_span" style={{ cursor: 'pointer', margin: 5 }}>Վերբեռնել ՀՎՀՀ</span>
                                        <input
                                            accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            onChange={(ev) => handleChange(ev, 'itn')} className="d-none" type="file" />

                                    </label> : null}
                                {+profile.admingroup === 1 ? '|' : ''}
                                {+profile.admingroup === 1 ?
                                    <Link to="/urs_news" style={{ color: '#5e8516' }}>
                                        <span className="custom_span"
                                            style={{ cursor: 'pointer', margin: 5 }}>Նորություններ</span>

                                    </Link> : null}
                                {+profile.admingroup === 1 ? '|' : ''}
                                {+profile.admingroup === 1 ?
                                    <Link to="/urs_admgroup" style={{ color: '#5e8516' }}>
                                        <span className="custom_span"
                                            style={{ cursor: 'pointer', margin: 5 }}>Telegram helper</span>
                                    </Link> : null}
                                {+profile.admingroup === 1 ? '|' : ''}

                                {/* {!profile.isLimited && REACT_APP_SERVER !== 'Beeline' ?
                                    <label>
                                        <span className="custom_span" style={{cursor: 'pointer', margin: 5}}>U-com-ի անջատումներ</span>
                                        <input
                                            accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            onChange={(ev) => handleChange(ev, 'turnoff')} className="d-none"
                                            type="file"/>

                                    </label> : null} */}
                            </div>
                            <div className="custom_span">Members: {data.total}</div>
                            <div className="custom_span">Pages: {Array.from({ length: Math.ceil(data.totalPages / 50) }).map((_, i) => {
                                const pageNum = i + 1
                                const isActive = pageNum === (Number(query.page) || 1)
                                return (
                                    <span
                                        key={i}
                                        className="custom_span"
                                        style={{
                                            cursor: 'pointer',
                                            marginRight: 4,
                                            ...(isActive ? { color: '#7ebc0a', fontWeight: 700, fontSize: '1.15em' } : {}),
                                        }}
                                        onClick={() => handlePagination(pageNum)}
                                    >
                                        {pageNum}{' '}
                                    </span>
                                )
                            })}</div>

                            <div className="custom_div d-flex align-items-center">Member Type: <span
                                onClick={() => handleActive('all')}>All</span> | <span
                                    onClick={() => handleActive('inactive')}>Registered</span> | <span
                                        onClick={() => handleActive('active')}>Added</span></div>

                        </div>
                        <form onSubmit={handleSearch} className="d-flex flex-column align-items-start search_block"
                            style={{ padding: '17px 0' }}>
                            <div>
                                <input type="text" placeholder="Գումար" value={gumar}
                                    onChange={(e) => setGumar(e.target.value)} />
                                <input type="text" placeholder="Համար" value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                            </div>
                            <button onClick={handleSearch} style={{ padding: '2px 30px', margin: '10px 0' }}
                                className="addBtn">Search
                            </button>
                        </form>
                    </div>
                    {isSticky && (
                        <table
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: headerLeft,
                                width: headerWidth,
                                zIndex: 1000,
                                background: '#fff',
                                // boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                            }}
                        >
                            <thead>
                                {renderHeader(true)}
                            </thead>
                        </table>
                    )}

                    <table ref={tableRef} style={{ width: '100%' }}>
                        <thead>
                            {renderHeader()}
                        </thead>
                        <tbody>
                            {loading ? <tr>
                                <td style={{ textAlign: 'center' }} colSpan={17}>Loading...</td>
                            </tr> : data.groupedArray?.length ? data.groupedArray.map(d => {
                                if (d?.members?.length === 1) {
                                    return <UrsLine key={_.uniqueId()} handleToCart={handleToCart} row={d?.members[0]} setIsOpen={setIsOpen}
                                        isOpen={isOpen} handleBlock={handleBlock} handleId={handleId}
                                        handleTest={handleTest} setBilling={setBilling} setTest={setTest}
                                        setComment={setComment} data={data} handleTerminated={handleTerminated} isUcom={profile.admingroup === 2} />
                                } else {
                                    return d?.members?.map((r, ind) => {
                                        if (ind === 0) {
                                            return <UrsLine key={_.uniqueId()} handleToCart={handleToCart} row={d?.members[0]} isGroup={true}
                                                setIsOpen={setIsOpen} isOpen={isOpen} handleBlock={handleBlock}
                                                handleId={handleId} handleTest={handleTest}
                                                setBilling={setBilling} setTest={setTest}
                                                setComment={setComment} data={data} handleTerminated={handleTerminated} isUcom={profile.admingroup === 2} />
                                        } else {
                                            return <UrsLine key={_.uniqueId()} handleToCart={handleToCart} row={r} isChild={true}
                                                setIsOpen={setIsOpen} isOpen={isOpen} handleBlock={handleBlock}
                                                handleId={handleId} handleTest={handleTest}
                                                setBilling={setBilling} setTest={setTest}
                                                setComment={setComment} data={data} handleTerminated={handleTerminated} isUcom={profile.admingroup === 2} />
                                        }
                                    })
                                }
                            }) : data.status === 'ok' && !data?.groupedArray?.length ?
                                <tr>
                                    <td style={{ textAlign: 'center' }} colSpan={17}>No Data</td>
                                </tr> : <tr>
                                    <td colSpan={17} />
                                </tr>


                            }
                            {+profile.admingroup === 1 && profile.price_permision ? <tr>
                                <td colSpan={15}>
                                    All
                                </td>
                                <td colSpan={1}>
                                    {data.totalSggumar} / {data.totalSggumarc}
                                </td>
                                <td colSpan={1}>
                                    {data.gumarall || 0} / {Math.round(data.gumarall * 0.7 / 1.2) || 0}
                                </td>
                            </tr> : null}
                        </tbody>

                    </table>
                </div>
            </div>
            {test.id ? <TestMode open={test} setOpen={setTest} setData={setData} /> : null}
            {comment ? <Comment open={comment} setOpen={setComment} /> : null}
            {add ? <UrsAdd open={add} setOpen={setAdd} /> : null}
            {billing.member ? <Billing open={billing} setOpen={setBilling} setData={setData} /> : null}
            {report ? <UrsReport open={report} setOpen={setReport} /> : null}
            {voip ? <UrsVoip open={voip} setOpen={setVoip} /> : null}
        </>
    );
}

export default Urs;
